<template>
    <v-container>
        <v-sheet v-if="!createPaymentLinkShow">
            <v-row v-if="error" class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 rounded" elevation="18">
                        <v-row justify="center">
                            <v-icon x-large>error_outline</v-icon>
                        </v-row>
                        <v-row justify="center">
                            <span style="color: gray; font-weight: bolder; font-style: italic">{{
                                "Something went wrong. Please try again." | t
                            }}</span>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
            <v-row v-else class="main-container" justify="space-around">
                <v-col justify="space-around">
                    <v-sheet class="pa-8 pt-2 rounded" elevation="18">
                        <v-tabs v-model="tabs" grow color="gray" class="mb-4">
                            <v-tab href="#regular" color="gray">
                                {{ "Regular payment" | t }}
                            </v-tab>

                            <v-tab href="#periodic" color="gray">
                                {{ "Periodic payment" | t }}
                            </v-tab>
                            <v-tab href="#bulk" color="gray">
                                {{ "Bulk payment" | t }}
                            </v-tab>
                        </v-tabs>
                        <create-regular-payment v-if="tabs === 'regular'" />
                        <create-periodic-payment v-else-if="tabs === 'periodic'" />
                        <create-bulk-payment v-else />
                    </v-sheet>
                </v-col>
            </v-row>
        </v-sheet>
        <v-sheet v-else class="pa-8 rounded" elevation="18">
            <v-col>
                <a
                    v-for="b in generatedBanks"
                    :key="b.name"
                    :href="`${api_url}/app/psd2/${tabs === 'bulk' ? 'bulk-payment' : 'payment'}/${payment_key}/${b.swift}`"
                    target="_blank"
                    >{{ `${api_url}/app/psd2/${tabs === 'bulk' ? 'bulk-payment' : 'payment'}/${payment_key}/${b.swift}` }}<br
                /></a>
                <a :href="`${api_url}/${tabs === 'bulk' ? 'bp' : 'p'}/${payment_slug}`" target="_blank">{{ `${api_url}/${tabs === 'bulk' ? 'bp' : 'p'}/${payment_slug}` }}<br /></a>
                <v-row class="justify-space-around mt-5 asc-banks-list">
                    <div v-for="b in generatedBanks" :key="b.swift">
                        <a
                            :class="'bank-link-' + b.swift"
                            class="bank-link"
                            :href="`${api_url}/app/psd2/${tabs === 'bulk' ? 'bulk-payment' : 'payment'}/${payment_key}/${b.swift}`"
                            target="_blank"
                            :id="b.swift"
                        >
                            <div style="text-align: center">
                                <img :alt="b.name + '_logo'" :src="`${assets_url}/img/banks/${b.swift}.svg`" />
                            </div>
                        </a>
                    </div>
                </v-row>
                <v-row class="mt-10" justify="center">
                    <v-btn id="generateNew" @click="resetCreatePaymentFlow">
                        {{ "Generate new" | t }}
                    </v-btn>
                </v-row>
            </v-col>
        </v-sheet>
    </v-container>
</template>

<script>
import settings from "../settings";
import { mapState, mapMutations } from "vuex";
import CreateRegularPayment from "@/views/create-regular-payment";
import CreatePeriodicPayment from "@/views/create-periodic-payment";
import CreateBulkPayment from "@/views/create-bulk-payment";

export default {
    name: "create-payment",
    components: { CreatePeriodicPayment, CreateRegularPayment, CreateBulkPayment },
    data() {
        return {
            assets_url: settings.assets_url,
            api_url: settings.api_url,
            url: settings.api_url,
            error: false,
            tabs: "regular"
        };
    },
    computed: {
        ...mapState(["payment_key", "createPaymentLinkShow", "generatedBanks", "user", "payment_slug"])
    },
    methods: {
        ...mapMutations(["resetCreatePaymentFlow"])
    },
    destroyed() {
        this.resetCreatePaymentFlow();
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
